<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm3>
            <v-layout row wrap>
              <v-flex xs12 v-if="enableResCurr">
                <v-text-field
                  v-model="form.resCurr"
                  :label="labels.resCurr"
                  :error-messages="errors.collect('resCurr')"
                  readonly
                  @click="showCurrencyHelpList = true"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="showCurrencyHelpList = true">mdi-magnify</v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs12 v-else>
                <v-subheader class="queryLabel">{{ labels.resCurr }}</v-subheader>
                <span class="queryLabel" v-if="commonInfo.resCurr !== null">{{ commonInfo.resCurr }}</span>
                <span v-else> - </span>
              </v-flex>
              <v-flex xs12>
                <v-subheader class="queryLabel">{{ labels.coInsPct }}</v-subheader>
                <span class="queryLabel" v-if="commonInfo.coInsPct !== null">{{ formatDisplayNumber(commonInfo.coInsPct, 6) }} %</span>
                <span v-else> - </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm9>
            <v-layout row wrap>
              <v-flex xs12 sm3>
                <v-subheader class="queryLabel">{{ labels.totRes }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="queryLabel" v-if="commonInfo.totRes !== null" style="display: inline-block; text-align: right; width: 200px">{{
                  formatDisplayNumber(commonInfo.totRes, 2)
                }}</span>
                <span v-else style="display: inline-block; text-align: right; width: 200px"> - </span>
              </v-flex>
              <v-flex xs12 sm3>
                <v-subheader class="queryLabel">{{ labels.planPayt }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="queryLabel" v-if="commonInfo.planPaytRes !== null" style="display: inline-block; text-align: right; width: 200px">{{
                  formatDisplayNumber(commonInfo.planPaytRes, 2)
                }}</span>
                <span v-else style="display: inline-block; text-align: right; width: 200px"> - </span>
              </v-flex>
              <v-flex xs12 sm3>
                <v-subheader class="queryLabel">{{ labels.paidAmt }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="queryLabel" v-if="commonInfo.paidAmtRes !== null" style="display: inline-block; text-align: right; width: 200px">{{
                  formatDisplayNumber(commonInfo.paidAmtRes, 2)
                }}</span>
                <span v-else style="display: inline-block; text-align: right; width: 200px"> - </span>
              </v-flex>
              <v-flex xs12 sm3>
                <v-subheader class="queryLabel">{{ labels.grossResOS }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="queryLabel" v-if="commonInfo.grossResOS !== null" style="display: inline-block; text-align: right; width: 200px">{{
                  formatDisplayNumber(commonInfo.grossResOS, 2)
                }}</span>
                <span v-else style="display: inline-block; text-align: right; width: 200px"> - </span>
              </v-flex>
              <v-flex xs12 sm3>
                <v-subheader class="queryLabel">{{ labels.netRes }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="queryLabel" v-if="commonInfo.netRes !== null" style="display: inline-block; text-align: right; width: 200px">{{
                  formatDisplayNumber(commonInfo.netRes, 2)
                }}</span>
                <span v-else style="display: inline-block; text-align: right; width: 200px"> - </span>
              </v-flex>
              <v-flex xs12 sm3>
                <v-subheader class="queryLabel">{{ labels.recAmt }}</v-subheader>
              </v-flex>
              <v-flex xs12 sm9>
                <span class="queryLabel" v-if="commonInfo.recAmt !== null" style="display: inline-block; text-align: right; width: 200px">{{
                  formatDisplayNumber(commonInfo.recAmt, 2)
                }}</span>
                <span v-else style="display: inline-block; text-align: right; width: 200px"> - </span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="showCurrencyHelpList" width="1000px">
      <currency-help-list @close="showCurrencyHelpList = false" @assign-currency-info="assignCurrency"></currency-help-list>
    </v-dialog>
  </v-container>
</template>

<script>
import { formatDisplayNumber } from '@/utils/number'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
export default {
  data() {
    return {
      showCurrencyHelpList: false,
      labels: {
        resCurr: 'Reserve Currency',
        totRes: 'Total Incurred Claim',
        planPayt: 'Planned to Pay',
        paidAmt: 'Payment Amount',
        grossResOS: 'Gross Reserve O/S',
        netRes: 'Net Reserve',
        recAmt: 'Recovery Amount',
        coInsPct: 'Our Share %'
      }
    }
  },
  props: {
    enableResCurr: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: undefined
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    resCurrList() {
      return this.$store.state.claims.claimParams.resCurrList
    }
  },
  methods: {
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    assignCurrency(data) {
      this.form.resCurr = data.curr
    }
  },
  components: {
    CurrencyHelpList
  }
}
</script>

<style>
</style>
